export default "__VITE_ASSET__BMsqS_jV__"